import {
  Infer,
  boolean,
  enums,
  nullable,
  object,
  optional,
  string,
} from "superstruct";
import { ModCfModal } from "components/Modal/types";
import { ReactNode } from "react";

export const cfAnchorSchema = object({
  id: string(),
  contentful_id: string(),
  internalLink: object({
    contentful_id: string(),
    slug: string(),
    node_locale: string(),
  }),
  anchorType: enums(["internalLink", "externalLink", "openModal"]),
  targetBlank: boolean(),
  dataTracking: nullable(string()),
  dataPosition: nullable(string()),
  params: string(),
  externalLink: string(),
  modal: nullable(ModCfModal),
  node_locale: string(),
});

export const cfJsonAnchorSchema = object({
  href: string(),
  blank: boolean(),
  dataTracking: optional(string()),
  dataPosition: optional(string()),
});

export type CfAnchorType = Infer<typeof cfAnchorSchema>;

export type CfAnchorProps = Infer<typeof cfAnchorSchema> & {
  children: ReactNode;
  livePreview?: boolean;
};
